import React from 'react';

const ChangePasswordIconChecked = () => (
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle opacity="0.5" cx="30" cy="30" r="30" fill="#DCD8EC" />
    <path d="M42 22L25.5 38L18 30.7273" stroke="#5941A9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);
export default ChangePasswordIconChecked;
